exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".cursorPointer{cursor:pointer}.cursorGrab{cursor:grab;cursor:-moz-grab}.cursorGrabbing{cursor:grabbing;cursor:-moz-grabbing}", "", {"version":3,"sources":["C:/Users/fpluq/Projects/groopus-vue/node_modules/vue-avatar-editor-improved/src/components/VueAvatar.vue"],"names":[],"mappings":"AACA,eACI,cAAgB,CACnB,AACD,YACI,YAAa,AACb,gBAAkB,CACrB,AACD,gBACI,gBAAiB,AACjB,oBAAsB,CACzB","file":"VueAvatar.vue","sourcesContent":["\n.cursorPointer{\n    cursor: pointer;\n}\n.cursorGrab{\n    cursor: grab;\n    cursor: -moz-grab;\n}\n.cursorGrabbing{\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e7a7d9d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-avatar-editor-improved/src/components/VueAvatar.vue
// module id = 941
// module chunks = 2 4 5